import ProfileUpdate from './ProfileUpdate.container';

export default ProfileUpdate;
